import { useState } from "react";
import { Ellipsis, UserRoundPlus } from "lucide-react";
import { Link } from "react-router-dom";
import useClickOutside from "../../../../CustomHooks/useClickOutside";
import updateSite from "../../../../assets/icons/updateSite.svg";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";

function SiteActions({
  siteId,
  siteName,
  categoryId,
  jnFtId,
  jbccFtId,
  jeId,
  machineId,
}) {
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));
  const { checkPermission } = UsePermissionsClaim();
  const addSite = checkPermission("add_site");
  const addOperator = checkPermission("add_station_operator");

  const handleShow = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  const encodedSiteName = encodeURIComponent(siteName);

  return (
    <div className="table-action-btn" onClick={handleShow} ref={dropdownRef}>
      <Ellipsis />
      {open === 1 && (
        <div className={`actionsWrap--u ${open === 1 ? "grid" : "invisible"}`}>
          {addSite && (
            <Link
              className="actionLink--u"
              to={`/site/update/${siteId}/${encodedSiteName}/${categoryId}/${jnFtId}/${jbccFtId}/${jeId}/${machineId}}`}
            >
              <img src={updateSite} alt="update site" className="w-6" />
              <span className="actionLinkText--u">Update Site</span>
            </Link>
          )}
          {addOperator && (
            <Link
              className="actionLink--u"
              to={`/site/add-operator/${siteId}/${encodedSiteName}`}
            >
              <UserRoundPlus/>
              <span className="actionLinkText--u">Add Operator</span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
export default SiteActions;
